import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CodeFeaturesService } from '@root/src/app/core/services/user/code-features.service';
import { CurrentUserStore } from '@root/src/app/user/store/current-user/current-user.store';
import { Observable } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { Constants } from '../utilities/constants';

@Injectable({
  providedIn: 'root'
})
export class ReloadOauthGuard implements CanActivate {
  constructor(
    private currentUserStore: CurrentUserStore,
    private codeFeatureService: CodeFeaturesService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,

  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree 
    {
      return this.currentUserStore.stateChanged.pipe(
        filter(state => state != null && state.currentUserCodeFeatures != null),
        first(),
        map(() => {
          if(this.codeFeatureService.a8OAuthEnabled) {
            return true;
          } else {
            setTimeout(() => {
              // Force a reload of the angular app to get redirected by the nginx proxy
              const reformattedUrl = state.url.replace(`/${Constants.OAUTH_AUTHORIZE_ROUTE}`, '/oauth/authorize');
              window.location.href = reformattedUrl;
            }, 0);
            return false;
          }
        })
      );
  }
  
}
